import {FC} from "react";
import styled from "styled-components";

const Style = styled.div``;

const NotFoundPage: FC = () => {
    return (
        <Style>
            Not Found 404
        </Style>
    )
};
export default NotFoundPage;
